import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { EmployerContactSubmissionChange } from './employer-contact-submission-change';
import { EmployerContactSubmissionChangeTypeEnum } from './employer-contact-submission-change-type.enum';

@Component({
  selector: 'app-employer-contact-submission-change-card',
  templateUrl: './employer-contact-submission-change-card.component.html',
  styleUrls: ['./employer-contact-submission-change-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EmployerContactSubmissionChangeCardComponent {
  @Input() cardData!: EmployerContactSubmissionChange;

  protected readonly EmployerContactSubmissionChangeTypeEnum = EmployerContactSubmissionChangeTypeEnum;
}
